import axios from '@/common/axios'
import { parse, isBefore } from 'date-fns'
import store from '@/store'
import router from '@/router'

// Helper
const showBeforeOver = function() {
    // This helper check to see if it's ok to show the before
    // over trigger. (Nothing to do with time here yet.)

    if (window.location.href.includes('staging')) {
        return false
    } else if (process.env.VUE_APP_BEFORE_OVER_PAGE_TRIGGER === 'on') {
        return true
    } else {
        return false
    }
}

const generalMiddleware = function(to, from, next) {
    // Start our vue-progressbar
    router.app.$Progress.start()

    // To set the title of each route
    document.title = to.meta.title

    return next()
}

const getDatetimeMiddleware = async function(to, from, next) {
    // Set global program date
    try {
        let result = await axios.get('/datetime')

        // We have to use `parse` here because our date comes like this:
        // 2019-02-01T10:43:43+00:00 when raw, and Safari doesn't like that
        // So we'll have it look like this with `parse` and toISOString()
        // 2019-02-01T10:43:43.000Z - Without .toISOString(), it looks like this
        // Fri Feb 01 2019 05:45:14 GMT-0500 (EST)
        let serverDate = parse(result.data.message).toISOString()

        await store.dispatch('datetime/setDate', serverDate)
    } catch (error) {
        // console.log('error: ', error)
    }

    return next()
}

const beforeMiddleware = function(to, from, next) {
    if (!showBeforeOver()) {
        return next()
    }

    // This takes both dates and compares them related to UTC time
    // We have to use `parse` here because of Safari's issue with parsing dates
    let beforeCheck = isBefore(
        parse(store.getters['datetime/datetime']).toISOString(),
        parse(process.env.VUE_APP_PROGRAM_START_DATE).toISOString()
    )
    if (beforeCheck === true) {
        return next({name: 'before'})
    }

    return next()
}

const overMiddleware = function(to, from, next) {
    if (!showBeforeOver()) {
        return next()
    }

    // This takes both dates and compares them related to UTC time
    // We have to use `parse` here because of Safari's issue with parsing dates
    let beforeCheck = isBefore(
        parse(store.getters['datetime/datetime']).toISOString(),
        parse(process.env.VUE_APP_PROGRAM_END_DATE).toISOString()
    )
    if (beforeCheck === false) {
        return next({name: 'over'})
    }

    return next()
}

export { generalMiddleware, getDatetimeMiddleware, beforeMiddleware, overMiddleware }